// Copyright (C) 2019 TANNER AG

import React, { useContext, useState } from "react";
import * as PropTypes from "prop-types";
import { Module } from "../module";
import { withStore } from "../../store/withstore";
import { TileButton } from "../../components/button";
import { TranslationContext } from "../../translation";

const HOLDING_PERIOD = [6, 8, 10, 12];

export const format = (year, translate) => {
	const parsedYear = parseInt(year, 0);
	if (isNaN(parsedYear)) {
		return "";
	}

	return `${parsedYear} ${translate("common.years")}`;
};

const HoldingPeriod = (props) => {
	const { store: { a }, storeAction } = props;
	const [value, setValue] = useState(a.holdingPeriod);
	const { translate } = useContext(TranslationContext);

	return (
		<Module
			id={props.id}
			activeModule={props.activeModule}
			nextModule={props.nextId}
			onActivate={props.setActiveModule}
			final={props.final}
			label="module.holdingperiod.title"
			title="module.holdingperiod.query"
			valueA={format(value, translate)}
			valueB={format(value, translate)}
			continueEnabled={value !== null}
			onContinue={() => storeAction.setHoldingPeriod(value)}
			queryA={(
				<React.Fragment>
					{HOLDING_PERIOD.map((period) => (
						<TileButton
							key={period}
							onClick={() => setValue(period)}
							active={value === period}
						>
							{format(period, translate)}
						</TileButton>
					))}
				</React.Fragment>
			)}
		/>
	);
};

HoldingPeriod.propTypes = {
	id: PropTypes.string.isRequired,
	nextId: PropTypes.string.isRequired,
	activeModule: PropTypes.string,
	setActiveModule: PropTypes.func
};

export default withStore(HoldingPeriod);



// WEBPACK FOOTER //
// ./src/tco/configuration/modules/holdingperiod.js